module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-runtime/node_modules/core-js/library/modules/_iterators.js
// module id = 84
// module chunks = 0